<template>
    <div>
        <Accordion>
            <AccordionTab header="Percepciones" >
                <DataTable :value="listPercepciones" :selection.sync="selectedPercepciones" selectionMode="multiple" responsiveLayout="scroll" dataKey="id" :metaKeySelection="false" style="margin-top: 2em" :scrollable="true" scrollHeight="400px" scrollDirection="both" >
                    <!-- <Column field="id" header="Clave" :styles="{'flex-grow':'1', 'flex-basis':'10px'}"></Column> -->
                    <Column field="clave" header="Clave" :styles="{'flex-grow':'1', 'flex-basis':'10px'}"></Column>
                    <Column field="concepto" header="Concepto" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
                    <Column field="tipoPercepcion.tipoPercepcion" header="Tipo Percepción" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
                </DataTable>
            </AccordionTab>

            <AccordionTab header="Deducciones">
                <DataTable :value="listDeducciones" :selection.sync="selectedDeducciones" selectionMode="multiple" responsiveLayout="scroll" dataKey="id" :metaKeySelection="false" style="margin-top: 2em" :scrollable="true" scrollHeight="400px" scrollDirection="both" >
                    <!-- <Column field="id" header="Clave" :styles="{'flex-grow':'1', 'flex-basis':'10px'}"></Column> -->
                    <Column field="clave" header="Clave" :styles="{'flex-grow':'1', 'flex-basis':'10px'}"></Column>
                    <Column field="concepto" header="Concepto" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
                    <Column field="tipoDeduccion.tipoDeduccion" header="Tipo Deducción" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
                </DataTable>
            </AccordionTab>
            <AccordionTab header="Otros Pagos">
                <DataTable :value="listOtrosPagos" :selection.sync="selectedOtrosPagos" selectionMode="multiple" responsiveLayout="scroll" dataKey="id" :metaKeySelection="false" style="margin-top: 2em" :scrollable="true" scrollHeight="400px" scrollDirection="both" >
                    <!-- <Column field="id" header="Clave" :styles="{'flex-grow':'1', 'flex-basis':'10px'}"></Column> -->
                    <Column field="clave" header="Clave" :styles="{'flex-grow':'1', 'flex-basis':'10px'}"></Column>
                    <Column field="concepto" header="Concepto" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
                    <Column field="tipoOtroPago.tipoOtroPago" header="Tipo Otro Pago" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
                </DataTable>
            </AccordionTab>
        </Accordion>
        <DataTable :value="itemsNomina" responsiveLayout="scroll" ref="dt" :exportFilename="nameFile">
            <template #header>
                <div style="text-align: left">
                    <div class="p-d-flex justify-center p-fluid grid formgrid col-12">
                        <div class="field col-1">
                            <Button icon="pi pi-external-link" label="Export" @click="exportCSV($event)" />
                        </div>
                        <div class="field col-2">
                            <div class="field-checkbox">
                                <Checkbox v-model="banderaHoras" :binary="true" />
                                <label >Horas extra</label>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <Column v-for="col of columnsNomina" :field="col.field" :header="col.header"></Column>
        </DataTable>
    </div>
</template>
<script>
    import axios from 'axios'
    import moment from 'moment'
    import XLSX from 'xlsx'

    export default {
        components: {

        },
        data() {
            return {
                selectedPercepciones: [],
                selectedDeducciones: [],
                selectedOtrosPagos: [],

                columnsNomina:[],
                itemsNomina: [],
                nameFile: '',
                banderaHoras: false,
            }
        },
        computed: {
            token() {
                return this.$store.state.usuario;
            },

            listPercepciones(){
                return this.$store.state.percepcionesStore;
            },
            
            listDeducciones(){
                return this.$store.state.deduccionesStore;
            },

            listOtrosPagos(){
                return this.$store.state.otrosPagosStore;
            },
            
            nomina(){
                return this.$store.state.nominaStore;
            }

        },
        created() {

        },
        methods: {
            async ConciliaConceptos(){
                this.columnsNomina = [];
                let concentrado = [];
                let rfc = {field: 'rfc', header: 'RFC'}
                let dias = {field: 'dias', header: 'DÍAS'}
                let rp = {field: 'rp', header: 'REGISTRO PATRONAL'}
                let rfcPo = {field: 'rfcPo', header: 'RFC PATRÓN ORIGEN'}
                concentrado.push(rfc);
                concentrado.push(dias);
                concentrado.push(rp);
                concentrado.push(rfcPo);
                //RECORREMOS LAS PERCEPCIONES
                for(let p of this.selectedPercepciones){
                    let gravado = {field: 'P', header: 'P|' + p.id + '|' + p.clave + '|' + p.concepto + '| Gravado'}
                    let exento = {field: 'P', header: 'P|' + p.id + '|' + p.clave + '|' + p.concepto + '| Exento'}
                    concentrado.push(gravado);
                    concentrado.push(exento);
                    gravado = {}
                    exento = {}
                }

                //HORAS EXTRAS
                if(this.banderaHoras){
                        let horasExtraDias = {field: 'H', header: 'H|DIAS'}
                        let horasExtraTipoHoras = {field: 'H', header: 'H|TIPO HORAS'}
                        let horasExtraHorasExtra = {field: 'H', header: 'H|HORAS EXTRA'}
                        let horasExtraImportePagado = {field: 'H', header: 'H|IMPORTE PAGADO'}
                        concentrado.push(horasExtraDias);
                        concentrado.push(horasExtraTipoHoras);
                        concentrado.push(horasExtraHorasExtra);
                        concentrado.push(horasExtraImportePagado);
                        horasExtraDias = {};
                        horasExtraTipoHoras = {};
                        horasExtraHorasExtra = {};
                        horasExtraImportePagado = {};
                    }

                //RECORREMOS LAS DEDUCCIONES
                for(let d of this.selectedDeducciones){
                    let deduccion = {field: 'D', header: 'D|' + d.id + '|' + d.clave + '|' + d.concepto + '| Importe'}
                    concentrado.push(deduccion);
                    deduccion = {};
                }

                //RECORREMOS LOS OTROS PAGOS
                for(let o of this.selectedOtrosPagos){
                    let otro = {field: 'O', header: 'O|' + o.id + '|' + o.clave + '|' + o.concepto + '| Importe'}
                    concentrado.push(otro);
                    otro = {};
                }

                this.columnsNomina = concentrado;
                let trabajadores = [];
                for(let t of this.nomina.trabajadores){
                    let trabajador = {
                        rfc: t.rfc
                    }
                    this.itemsNomina.push(trabajador);
                    trabajador = {};
                }
                // console.log(this.nomina.trabajadores);
            },
        
            async exportCSV() {
                await this.ConciliaConceptos()
                console.log(this.itemsNomina)
                console.log(this.columnsNomina)
                let listaIdentificadores = this.columnsNomina
                let listaValores = this.itemsNomina

                const listaObjetos = [];

                for (let i = 0; i < listaValores.length; i++) {
                    const objeto = {};
                    for (let j = 0; j < listaIdentificadores.length; j++) {
                        if(j == 0){
                            objeto[listaIdentificadores[j].header] = listaValores[i].rfc;
                        }else{
                            objeto[listaIdentificadores[j].header] = '';
                        }
                    }
                    listaObjetos.push(objeto);
                }

                const workbook = XLSX.utils.book_new();
                const sheet = XLSX.utils.json_to_sheet(listaObjetos);
                XLSX.utils.book_append_sheet(workbook, sheet, 'Hoja1');
                XLSX.writeFile(workbook, this.$store.state.nominaStore.descripcion + '.xlsx');

                // this.nameFile = 'Nomina_ejemplo_01'
                // this.$refs.dt.exportCSV();
            }
        },
    }
    </script>
    <style>
    </style>